export const categories = [
  { slug: 'dianying', name: '电影', icon: 'ri-movie-2-line' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-2-line' },
  { slug: 'dongman', name: '动漫', icon: 'ri-emotion-laugh-line' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-live-line' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-camera-lens-line' },
];

export const movies = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'dianying',
    year: 2026,
    rating: 9.2,
    genre: '科幻 / 冒险',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    duration: '148分钟',
    description: '太阳急速老化，持续膨胀，将在三百年后吞没整个太阳系。面对绝境，人类在地球表面建造出巨大的推进器，开启了长达2500年的"流浪地球"计划。在这条漫长而危险的道路上，人类将面对前所未有的挑战。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20featuring%20massive%20planetary%20engines%20on%20Earth%20surface%2C%20dramatic%20cosmic%20background%20with%20glowing%20nebula%2C%20cinematic%20lighting%20with%20deep%20oranges%20and%20cool%20teals%2C%20epic%20scale%2C%20Chinese%20science%20fiction%20blockbuster%20style%2C%20atmospheric%20and%20grand%20composition&width=400&height=560&seq=movie-poster-01&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20featuring%20massive%20planetary%20engines%20on%20Earth%20surface%2C%20dramatic%20cosmic%20background%20with%20glowing%20nebula%2C%20cinematic%20lighting%20with%20deep%20oranges%20and%20cool%20teals%2C%20epic%20scale%2C%20Chinese%20science%20fiction%20blockbuster%20style%2C%20atmospheric%20and%20grand%20composition&width=640&height=360&seq=movie-land-01&orientation=landscape',
    featured: true,
    trending: true,
    isNew: false,
  },
  {
    id: 2,
    title: '长安三万里2',
    category: 'dongman',
    year: 2026,
    rating: 9.0,
    genre: '动画 / 历史',
    director: '追光动画',
    actors: ['杨天翔', '凌振赫'],
    duration: '168分钟',
    description: '安史之乱后，大唐帝国由盛转衰。诗人高适困守孤城，回忆起与李白数十年的深厚友谊，那些诗酒趁年华的岁月，那些满怀豪情壮志的往事，都成为了永恒的回忆。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20in%20Tang%20Dynasty%20aesthetic%2C%20two%20poets%20standing%20under%20moonlight%20with%20ancient%20Chang%20an%20city%20in%20background%2C%20gold%20and%20crimson%20color%20palette%2C%20poetic%20atmosphere%2C%20traditional%20Chinese%20ink%20wash%20painting%20style%20blended%20with%20modern%20animation%2C%20elegant%20and%20artistic%20composition&width=400&height=560&seq=movie-poster-02&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20in%20Tang%20Dynasty%20aesthetic%2C%20two%20poets%20standing%20under%20moonlight%20with%20ancient%20Chang%20an%20city%20in%20background%2C%20gold%20and%20crimson%20color%20palette%2C%20poetic%20atmosphere%2C%20traditional%20Chinese%20ink%20wash%20painting%20style%20blended%20with%20modern%20animation%2C%20elegant%20and%20artistic%20composition&width=640&height=360&seq=movie-land-02&orientation=landscape',
    featured: true,
    trending: true,
    isNew: false,
  },
  {
    id: 3,
    title: '封神第二部',
    category: 'dianying',
    year: 2026,
    rating: 8.8,
    genre: '奇幻 / 动作',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤'],
    duration: '150分钟',
    description: '商朝末年，纣王暴虐无道。姜子牙携封神榜下山，辅佐西岐武王讨伐商朝。一场跨越人、仙、妖三界的宏大战争就此展开，封神大战正式拉开帷幕。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20movie%20poster%2C%20ancient%20mythological%20warriors%20in%20ornate%20armor%2C%20mystical%20creatures%20and%20deities%20in%20dramatic%20battle%20scene%2C%20gold%20and%20crimson%20tones%20with%20divine%20light%20effects%2C%20grand%20cinematic%20scale%2C%20traditional%20Chinese%20mythology%20aesthetic&width=400&height=560&seq=movie-poster-03&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20movie%20poster%2C%20ancient%20mythological%20warriors%20in%20ornate%20armor%2C%20mystical%20creatures%20and%20deities%20in%20dramatic%20battle%20scene%2C%20gold%20and%20crimson%20tones%20with%20divine%20light%20effects%2C%20grand%20cinematic%20scale%2C%20traditional%20Chinese%20mythology%20aesthetic&width=640&height=360&seq=movie-land-03&orientation=landscape',
    featured: true,
    trending: false,
    isNew: true,
  },
  {
    id: 4,
    title: '狂飙',
    category: 'dianshiju',
    year: 2023,
    rating: 9.5,
    genre: '剧情 / 犯罪',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐'],
    duration: '39集',
    description: '京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。直到全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海，一场声势浩大的扫黑除恶行动就此展开。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20TV%20series%20poster%20with%20intense%20dramatic%20atmosphere%2C%20two%20male%20leads%20in%20confrontation%2C%20moody%20noir%20lighting%20with%20deep%20shadows%2C%20urban%20Chinese%20cityscape%20at%20night%2C%20suspenseful%20and%20gritty%20aesthetic%2C%20high%20contrast%20cinematic%20photography&width=400&height=560&seq=movie-poster-04&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20TV%20series%20poster%20with%20intense%20dramatic%20atmosphere%2C%20two%20male%20leads%20in%20confrontation%2C%20moody%20noir%20lighting%20with%20deep%20shadows%2C%20urban%20Chinese%20cityscape%20at%20night%2C%20suspenseful%20and%20gritty%20aesthetic%2C%20high%20contrast%20cinematic%20photography&width=640&height=360&seq=movie-land-04&orientation=landscape',
    featured: false,
    trending: true,
    isNew: false,
  },
  {
    id: 5,
    title: '繁花',
    category: 'dianshiju',
    year: 2024,
    rating: 9.3,
    genre: '剧情 / 爱情',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣'],
    duration: '30集',
    description: '九十年代的上海，改革开放的春风吹遍大地。青年阿宝凭借自己的智慧和努力，在商海中崛起，成为那个时代最耀眼的弄潮儿。在这座繁花似锦的城市里，他经历了事业的起伏和情感的纠葛。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Nostalgic%201990s%20Shanghai%20TV%20series%20poster%2C%20elegant%20period%20drama%20aesthetic%2C%20warm%20golden%20lighting%20with%20vintage%20tones%2C%20fashionable%20characters%20in%20retro%20Shanghai%20setting%2C%20Wong%20Kar-wai%20style%20cinematography%2C%20dreamy%20and%20romantic%20atmosphere&width=400&height=560&seq=movie-poster-05&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Nostalgic%201990s%20Shanghai%20TV%20series%20poster%2C%20elegant%20period%20drama%20aesthetic%2C%20warm%20golden%20lighting%20with%20vintage%20tones%2C%20fashionable%20characters%20in%20retro%20Shanghai%20setting%2C%20Wong%20Kar-wai%20style%20cinematography%2C%20dreamy%20and%20romantic%20atmosphere&width=640&height=360&seq=movie-land-05&orientation=landscape',
    featured: false,
    trending: true,
    isNew: false,
  },
  {
    id: 6,
    title: '哪吒之魔童闹海',
    category: 'dongman',
    year: 2025,
    rating: 9.1,
    genre: '动画 / 奇幻',
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫'],
    duration: '144分钟',
    description: '天劫之后，哪吒和敖丙虽保住了灵魂，但肉身已毁。太乙真人欲用七色宝莲为二人重塑肉身，然而在此过程中却遭遇重重阻碍。哪吒和敖丙的命运将何去何从？',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20film%20poster%2C%20young%20mythological%20hero%20with%20fiery%20red%20ribbons%20and%20cosmic%20powers%2C%20dynamic%20action%20pose%20with%20swirling%20energy%20effects%2C%20vibrant%20red%20and%20gold%20color%20palette%2C%20epic%20celestial%20backdrop%2C%20Chinese%20mythology%20meets%20modern%20animation%20style&width=400&height=560&seq=movie-poster-06&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20film%20poster%2C%20young%20mythological%20hero%20with%20fiery%20red%20ribbons%20and%20cosmic%20powers%2C%20dynamic%20action%20pose%20with%20swirling%20energy%20effects%2C%20vibrant%20red%20and%20gold%20color%20palette%2C%20epic%20celestial%20backdrop%2C%20Chinese%20mythology%20meets%20modern%20animation%20style&width=640&height=360&seq=movie-land-06&orientation=landscape',
    featured: true,
    trending: true,
    isNew: true,
  },
  {
    id: 7,
    title: '奔跑吧·生态篇',
    category: 'zongyi',
    year: 2026,
    rating: 8.2,
    genre: '真人秀 / 户外',
    director: '浙江卫视',
    actors: ['李晨', '郑恺', '沙溢'],
    duration: '12期',
    description: '跑男团再次集结，开启全新生态主题之旅。成员们将深入中国各地的自然保护区和生态景区，通过有趣的游戏和挑战，向观众传递环保理念，展现美丽中国的壮丽山河。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Outdoor%20variety%20show%20poster%20with%20energetic%20cast%20in%20vibrant%20natural%20scenery%2C%20lush%20green%20mountains%20and%20clear%20waters%20in%20background%2C%20bright%20and%20cheerful%20summer%20atmosphere%2C%20group%20of%20celebrities%20in%20casual%20colorful%20outfits%2C%20fun%20and%20dynamic%20composition&width=400&height=560&seq=movie-poster-07&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Outdoor%20variety%20show%20poster%20with%20energetic%20cast%20in%20vibrant%20natural%20scenery%2C%20lush%20green%20mountains%20and%20clear%20waters%20in%20background%2C%20bright%20and%20cheerful%20summer%20atmosphere%2C%20group%20of%20celebrities%20in%20casual%20colorful%20outfits%2C%20fun%20and%20dynamic%20composition&width=640&height=360&seq=movie-land-07&orientation=landscape',
    featured: false,
    trending: false,
    isNew: true,
  },
  {
    id: 8,
    title: '地球脉动III',
    category: 'jilupian',
    year: 2026,
    rating: 9.7,
    genre: '自然 / 纪录',
    director: 'BBC Studios',
    actors: ['大卫·爱登堡'],
    duration: '8集',
    description: '《地球脉动》系列时隔十年再度回归，采用最先进的拍摄技术，记录了地球上最壮观的自然奇观和动物行为。从深海到极地，从沙漠到雨林，展现了一个生机勃勃又危机四伏的自然世界。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20showcasing%20stunning%20wildlife%20and%20landscapes%2C%20majestic%20animals%20in%20their%20natural%20habitats%2C%20breathtaking%20aerial%20views%20of%20Earth%20diverse%20ecosystems%2C%20vibrant%20natural%20colors%20with%20cinematic%20quality%2C%20awe-inspiring%20and%20educational%20atmosphere&width=400&height=560&seq=movie-poster-08&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20showcasing%20stunning%20wildlife%20and%20landscapes%2C%20majestic%20animals%20in%20their%20natural%20habitats%2C%20breathtaking%20aerial%20views%20of%20Earth%20diverse%20ecosystems%2C%20vibrant%20natural%20colors%20with%20cinematic%20quality%2C%20awe-inspiring%20and%20educational%20atmosphere&width=640&height=360&seq=movie-land-08&orientation=landscape',
    featured: false,
    trending: false,
    isNew: true,
  },
  {
    id: 9,
    title: '奥本海默',
    category: 'dianying',
    year: 2023,
    rating: 8.9,
    genre: '传记 / 历史',
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '艾米莉·布朗特'],
    duration: '180分钟',
    description: '讲述了美国"原子弹之父"罗伯特·奥本海默在二战期间领导曼哈顿计划研制原子弹的故事，以及战后他在政治风波中遭受的审查和迫害。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Biographical%20drama%20film%20poster%20with%20intense%20portrait%20of%20scientist%20against%20atomic%20explosion%20backdrop%2C%20stark%20black%20and%20white%20contrast%20with%20orange%20fire%20elements%2C%20dramatic%20and%20contemplative%20mood%2C%20historical%20period%20aesthetic%2C%20cinematic%20masterpiece%20style&width=400&height=560&seq=movie-poster-09&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Biographical%20drama%20film%20poster%20with%20intense%20portrait%20of%20scientist%20against%20atomic%20explosion%20backdrop%2C%20stark%20black%20and%20white%20contrast%20with%20orange%20fire%20elements%2C%20dramatic%20and%20contemplative%20mood%2C%20historical%20period%20aesthetic%2C%20cinematic%20masterpiece%20style&width=640&height=360&seq=movie-land-09&orientation=landscape',
    featured: false,
    trending: true,
    isNew: false,
  },
  {
    id: 10,
    title: '庆余年第二季',
    category: 'dianshiju',
    year: 2024,
    rating: 9.0,
    genre: '古装 / 权谋',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明'],
    duration: '36集',
    description: '范闲从北齐归来后，面对更加复杂的朝堂局势。他一方面要应对庆帝的试探和考验，另一方面要保护自己珍视的人。在这个充满权谋和危险的世界里，范闲将如何走出属于自己的道路？',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20series%20poster%2C%20elegant%20period%20costumes%20with%20intricate%20details%2C%20palace%20intrigue%20atmosphere%2C%20warm%20amber%20and%20gold%20lighting%2C%20regal%20and%20mysterious%20mood%2C%20sophisticated%20ancient%20Chinese%20aesthetic%20with%20modern%20cinematic%20quality&width=400&height=560&seq=movie-poster-10&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20series%20poster%2C%20elegant%20period%20costumes%20with%20intricate%20details%2C%20palace%20intrigue%20atmosphere%2C%20warm%20amber%20and%20gold%20lighting%2C%20regal%20and%20mysterious%20mood%2C%20sophisticated%20ancient%20Chinese%20aesthetic%20with%20modern%20cinematic%20quality&width=640&height=360&seq=movie-land-10&orientation=landscape',
    featured: false,
    trending: true,
    isNew: false,
  },
  {
    id: 11,
    title: '沙丘2',
    category: 'dianying',
    year: 2024,
    rating: 8.7,
    genre: '科幻 / 冒险',
    director: '丹尼斯·维伦纽瓦',
    actors: ['提莫西·查拉梅', '赞达亚'],
    duration: '166分钟',
    description: '保罗·厄崔迪斯与弗雷曼人联手，踏上了一条通往复仇和拯救的史诗之旅。他必须在挚爱和宇宙命运之间做出选择，并努力阻止只有他能预见的可怕未来。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20film%20poster%20with%20vast%20desert%20landscape%20and%20giant%20sandworms%2C%20dramatic%20golden%20and%20brown%20tones%2C%20mysterious%20Fremen%20figures%20in%20stillsuits%2C%20grand%20scale%20cinematic%20composition%2C%20atmospheric%20and%20immersive%20desert%20world%20aesthetic&width=400&height=560&seq=movie-poster-11&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20film%20poster%20with%20vast%20desert%20landscape%20and%20giant%20sandworms%2C%20dramatic%20golden%20and%20brown%20tones%2C%20mysterious%20Fremen%20figures%20in%20stillsuits%2C%20grand%20scale%20cinematic%20composition%2C%20atmospheric%20and%20immersive%20desert%20world%20aesthetic&width=640&height=360&seq=movie-land-11&orientation=landscape',
    featured: false,
    trending: false,
    isNew: false,
  },
  {
    id: 12,
    title: '间谍过家家2',
    category: 'dongman',
    year: 2025,
    rating: 8.9,
    genre: '动画 / 喜剧',
    director: 'WIT STUDIO',
    actors: ['江口拓也', '种崎敦美'],
    duration: '25集',
    description: '间谍"黄昏"、杀手"约尔"和超能力少女"阿尼亚"这个临时组成的家庭，继续着他们各自秘密的日常生活。在充满欢笑和温情的日子里，这个特别家庭的羁绊也愈发深厚。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20series%20poster%20with%20stylish%20spy%20family%20theme%2C%20three%20characters%20in%20elegant%20formal%20wear%2C%20playful%20and%20heartwarming%20atmosphere%2C%20soft%20pastel%20colors%20with%20pops%20of%20bold%20accents%2C%20clean%20animation%20art%20style%2C%20charming%20family%20comedy%20aesthetic&width=400&height=560&seq=movie-poster-12&orientation=portrait',
    landscapeUrl: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20series%20poster%20with%20stylish%20spy%20family%20theme%2C%20three%20characters%20in%20elegant%20formal%20wear%2C%20playful%20and%20heartwarming%20atmosphere%2C%20soft%20pastel%20colors%20with%20pops%20of%20bold%20accents%2C%20clean%20animation%20art%20style%2C%20charming%20family%20comedy%20aesthetic&width=640&height=360&seq=movie-land-12&orientation=landscape',
    featured: false,
    trending: false,
    isNew: true,
  },
];